import { store } from '@/state';

/**
 * Update a sparkline visualization
 * @param containerId - ID of the sparkline container element
 * @param data - Array of values to display
 */
export function updateSparkline(containerId: string, data: number[]): void {
  const container = document.getElementById(containerId);
  if (!container) return;

  // Clear existing bars
  container.innerHTML = '';

  const max = Math.max(...data, 1);
  const width = container.clientWidth;
  const barWidth = Math.floor(width / data.length) - 1;

  data.forEach((value, index) => {
    const bar = document.createElement('div');
    bar.className = 'sparkline-bar';
    bar.style.left = `${index * (barWidth + 1)}px`;
    bar.style.width = `${barWidth}px`;
    bar.style.height = `${(value / max) * 100}%`;
    container.appendChild(bar);
  });
}

/**
 * Update all sparklines with current data
 */
export function updateAllSparklines(): void {
  const state = store.getState();
  updateSparkline('flows-sparkline', state.flowsSparklineData);
  updateSparkline('bandwidth-sparkline', state.bandwidthSparklineData);
}
